import { Body, Head, Html, Img, Link, Text } from "@react-email/components";
import { Email as Styles } from "themes/styles";
import { IPotluck } from "interfaces";
import { Helpers, Routes } from "utils";

// components
import { Footer } from "./components";

export type Props = {
  url: string;
  name: string;
  potluck: IPotluck;
};

export const Potluck = ({ url, name, potluck }: Props) => {
  return (
    <Html lang="en">
      <Head />
      <Body style={Styles.body}>
        <Img style={Styles.img} src={Helpers.getImage("email_potluck.png")} />
        <div style={Styles.content}>
          {/* header */}
          <Text style={Styles.textBold}>Hello {name},</Text>

          {/* paragraph */}
          <Text style={Styles.textBold}>
            Thank you for using Potluck'IN! Manage your potluck using the link
            below, or{" "}
            <Link
              href={Helpers.generateInterpolatedUrl(Routes.useronboarding)}
              style={Styles.link}
            >
              sign up
            </Link>{" "}
            now to get your full Potluck'IN experience for free.
          </Text>

          {/* potluck */}
          <Text style={Styles.text}>
            {potluck.party_name} ({potluck.date})
          </Text>

          {/* button */}
          <Link href={url} style={Styles.button}>
            Manage My Potluck
          </Link>
        </div>
        <Footer />
      </Body>
    </Html>
  );
};
